import React, { FC } from 'react';
import classNames from 'classnames';

import { IconType } from '../icon.type';

const GptIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={classNames(className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 57 57"
      >
        <g clipPath="url(#clip0_158_738)">
          <circle
            cx="28.5"
            cy="28.5"
            r="28.5"
            fill="color(display-p3 0.9338 0.9781 0.9917)"
          ></circle>
          <path
            fill="color(display-p3 0.1600 0.5312 0.8000)"
            d="M24.205 29.928c0 3.16-1.909 5.072-5.132 5.072-3.456 0-5.573-2.267-5.573-6.036C13.5 25.25 15.617 23 19.017 23c2.702 0 4.739 1.6 5.084 3.946h-2.43c-.353-1.213-1.34-1.937-2.646-1.937-1.909 0-3.055 1.455-3.055 3.923 0 2.515 1.219 4.05 3.143 4.05 1.58 0 2.678-.972 2.726-2.41l.008-.185H19.33v-1.769h4.876zM25.809 23.2h4.706c2.374 0 4.01 1.584 4.01 3.972 0 2.379-1.692 3.97-4.13 3.97H28.23v3.657H25.81zm2.421 1.922v4.123h1.636c1.387 0 2.197-.74 2.197-2.065 0-1.319-.802-2.058-2.189-2.058zM41.148 34.8h-2.421v-9.598h-3.344v-2.001H44.5v2.001h-3.352z"
          ></path>
        </g>
        {/* <defs>
          <clipPath id="clip0_158_738">
            <path fill="#fff" d="M0 0h57v57H0z"></path>
          </clipPath>
        </defs> */}
      </svg>
    </div>
  );
};

export default GptIcon;
